module.exports = __webpack_public_path__ + "img/gcqianz-icon.6eea131d.png";